var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoltBrush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 113,
    viewBox: "0 0 56 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0939 110.474C47.0402 110.71 45.9903 110.064 45.7263 109.017L25.0885 27.1493C24.5039 24.8301 25.9473 22.4853 28.2814 21.9629V21.9629C30.6154 21.4404 32.9207 22.946 33.3806 25.2932L49.6141 108.146C49.8218 109.206 49.1476 110.238 48.0939 110.474V110.474Z",
    fill: "#CEECB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6141 108.146L48.6328 108.339L49.6141 108.146ZM33.3806 25.2932L34.3619 25.1009L33.3806 25.2932ZM25.0885 27.1493L24.1189 27.3937L25.0885 27.1493ZM45.7263 109.017L46.696 108.772L45.7263 109.017ZM46.696 108.772L26.0582 26.9049L24.1189 27.3937L44.7567 109.261L46.696 108.772ZM32.3993 25.4855L48.6328 108.339L50.5955 107.954L34.3619 25.1009L32.3993 25.4855ZM48.6328 108.339C48.7362 108.867 48.4004 109.381 47.8755 109.498L48.3123 111.45C49.8948 111.096 50.9073 109.546 50.5955 107.954L48.6328 108.339ZM28.4998 22.9387C30.2847 22.5392 32.0476 23.6906 32.3993 25.4855L34.3619 25.1009C33.7939 22.2015 30.9461 20.3416 28.0629 20.987L28.4998 22.9387ZM26.0582 26.9049C25.6111 25.1313 26.7149 23.3383 28.4998 22.9387L28.0629 20.987C25.1797 21.6324 23.3966 24.5288 24.1189 27.3937L26.0582 26.9049ZM44.7567 109.261C45.1531 110.834 46.7298 111.804 48.3123 111.45L47.8755 109.498C47.3505 109.616 46.8275 109.294 46.696 108.772L44.7567 109.261Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9136 4.78655C22.4408 3.68426 23.8249 3.37445 24.7717 4.1468C27.3945 6.28638 31.9888 10.355 32.5926 13.0524C33.4442 16.8571 31.0103 20.6408 27.1562 21.5035C23.3021 22.3662 19.4873 19.9812 18.6357 16.1766C18.0319 13.4791 20.4532 7.84014 21.9136 4.78655Z",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2409_28953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 3,
    width: 15,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9136 4.78655C22.4408 3.68426 23.8249 3.37445 24.7717 4.1468C27.3945 6.28639 31.9888 10.355 32.5926 13.0524C33.4442 16.8571 31.0103 20.6408 27.1562 21.5035C23.3021 22.3662 19.4873 19.9812 18.6357 16.1766C18.0319 13.4791 20.4532 7.84014 21.9136 4.78655Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2409_28953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8372 15.5124C12.0456 15.4046 10.5212 14.1688 10.045 12.4383L7.42634 2.92127L39.7793 -5.9809L42.398 3.53613C42.8741 5.26662 42.1965 7.10831 40.7123 8.11748V8.11748C39.9455 8.63886 39.0275 8.89145 38.1019 8.83575L37.3178 8.78856C35.8838 8.70226 34.4616 9.09358 33.2736 9.90133V9.90133C32.0857 10.7091 30.6635 11.1004 29.2295 11.0141V11.0141C27.7955 10.9278 26.3734 11.3191 25.1854 12.1269V12.1269C23.9974 12.9346 22.5753 13.3259 21.1413 13.2396V13.2396C19.7073 13.1533 18.2851 13.5447 17.0972 14.3524L16.4476 14.7941C15.6807 15.3155 14.7628 15.5681 13.8372 15.5124V15.5124Z",
    fill: "url(#paint0_linear_2409_28953)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0284 21.4561L3 63.5786H18.6654L3 103.513L44.0284 63.5786H28.363L44.0284 21.4561Z",
    fill: "url(#paint1_linear_2409_28953)",
    stroke: "#262626",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2409_28953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 2,
    width: 27,
    height: 59
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.456 60.4983L42.044 41.3076L32 6L22.5 2.5L16.5 12.5L31.456 60.4983Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2409_28953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0939 110.474C47.0402 110.71 45.9903 110.064 45.7263 109.017L25.0885 27.1492C24.5039 24.83 25.9473 22.4852 28.2814 21.9628V21.9628C30.6154 21.4403 32.9207 22.9459 33.3806 25.2931L49.6141 108.146C49.8218 109.206 49.1476 110.238 48.0939 110.474V110.474Z",
    fill: "#CEECB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3806 25.2931L34.3619 25.1008L33.3806 25.2931ZM46.696 108.772L26.0582 26.9047L24.1189 27.3936L44.7567 109.261L46.696 108.772ZM32.3993 25.4854L48.6328 108.339L50.5955 107.954L34.3619 25.1008L32.3993 25.4854ZM48.6328 108.339C48.7362 108.866 48.4004 109.381 47.8755 109.498L48.3123 111.45C49.8948 111.096 50.9073 109.545 50.5955 107.954L48.6328 108.339ZM28.4998 22.9386C30.2847 22.5391 32.0476 23.6904 32.3993 25.4854L34.3619 25.1008C33.7939 22.2014 30.9461 20.3415 28.0629 20.9869L28.4998 22.9386ZM26.0582 26.9047C25.6111 25.1312 26.7149 23.3381 28.4998 22.9386L28.0629 20.9869C25.1797 21.6323 23.3966 24.5287 24.1189 27.3936L26.0582 26.9047ZM44.7567 109.261C45.1531 110.833 46.7298 111.804 48.3123 111.45L47.8755 109.498C47.3505 109.616 46.8275 109.294 46.696 108.772L44.7567 109.261Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9136 4.78728C22.4408 3.68499 23.8249 3.37518 24.7717 4.14753C27.3945 6.28712 31.9888 10.3557 32.5926 13.0532C33.4442 16.8578 31.0103 20.6415 27.1562 21.5042C23.3021 22.3669 19.4873 19.982 18.6357 16.1773C18.0319 13.4798 20.4532 7.84087 21.9136 4.78728Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4432 10.7655C30.7299 10.974 29.9814 11.06 29.2296 11.0148C27.7956 10.9285 26.3735 11.3198 25.1855 12.1276C23.9975 12.9353 22.5753 13.3266 21.1414 13.2403C20.3131 13.1905 19.4888 13.3 18.7113 13.557C19.2324 10.7079 20.8351 7.04245 21.9137 4.78723C22.4409 3.68494 23.8249 3.37513 24.7717 4.14748C26.7227 5.73894 29.7643 8.39765 31.4432 10.7655Z",
    fill: "url(#paint2_linear_2409_28953)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2409_28953",
    x1: 16.7488,
    y1: 7.77305,
    x2: 29.2126,
    y2: 4.34352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2409_28953",
    x1: 23.5142,
    y1: 21.4561,
    x2: 23.5142,
    y2: 103.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2409_28953",
    x1: 16.7487,
    y1: 7.77378,
    x2: 29.2125,
    y2: 4.34425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F7CFDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltBrush);
export default __webpack_public_path__ + "static/media/bolt_brush.e698229124dc187af657c141462a9027.svg";
export { ForwardRef as ReactComponent };